import React from 'react';

interface IBaseImageProps {
  imgSrc: string;
  imgAlt: string;
  imgClass?: string;
}

const BaseImage: React.FC<IBaseImageProps> = ({ imgSrc, imgAlt, imgClass }) => {
  return (
    <div>
      <img src={imgSrc} alt={imgAlt} className={`${imgClass}`} />
    </div>
  );
};

export default BaseImage;
